import { render, staticRenderFns } from "./CodeHtml.vue?vue&type=template&id=88d32120&scoped=true&"
import script from "./CodeHtml.vue?vue&type=script&lang=js&"
export * from "./CodeHtml.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88d32120",
  null
  
)

export default component.exports